<template>
	<div class="show-amount">
		<div v-if="isSpecialPrice">
			<span class="money-1" style="font-weight: normal">{{ price == 9999999.99 ? '可询价' : price }}</span>
		</div>
		<div v-else-if="priceSegment.textOnly">
			<span class="money-1" style="font-weight: normal">{{ priceSegment.integer }}</span>
		</div>
		<div v-else>
			<span class="money-1">￥</span>
			<span class="money-2">{{ priceSegment.integer }}</span>
			<span class="money-3">.{{ priceSegment.decimal }}</span>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { getPriceSegment } from '@/utils/utils';

const userInfo = useUserInfo();

const props = defineProps({
	price: {
		type: [Number, String],
		default: '',
	},
});

// 判断是否为特殊价格文本（可询价、登录可见、认证可见等）
const isSpecialPrice = computed(() => {
	const p = props.price;
	if (p == 9999999.99 || p === '9999999.99') return true;
	return typeof p === 'string' && p !== '0' && p !== '0.00' && isNaN(Number(p));
});

// 价格分段（整数和小数）
const priceSegment = computed(() => {
	if (isSpecialPrice.value) {
		return { integer: '0', decimal: '00' };
	}
	return getPriceSegment(props.price, userInfo.value);
});
</script>

<style scoped lang="scss">
.show-amount {
	font-family: 'Source Han Sans', '思源黑体', sans-serif;
	color: #eb3535;
}

.money-1 {
	font-size: 0.9812rem;
	font-weight: normal;
}

.money-2 {
	font-size: 1.358rem;
	font-weight: bold;
}

.money-3 {
	font-size: 0.9812rem;
	font-weight: normal;
}
</style>
